import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { L10nTranslationService } from 'angular-l10n';
import { AppConfig } from 'src/app/app.config';

@Injectable({ providedIn: 'root' })
export class BrowserTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translation = inject(L10nTranslationService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const deepestPrimaryChild = this.findDeepestPrimaryChild(snapshot.root);
    if (!deepestPrimaryChild) {
      return;
    }

    const pageNameKey = deepestPrimaryChild.data['name'] as string;
    const pageTitle = pageNameKey?.length ? this.translation.translate(pageNameKey) : '';

    this.title.setTitle(this.buildBrowserTitle(pageTitle));
  }

  private findDeepestPrimaryChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    let current = route;
    while (current?.firstChild) {
      current = current.firstChild;
    }

    return current?.outlet === 'primary' ? current : null;
  }

  private buildBrowserTitle(pageTitle: string): string {
    const hasTitle = !!pageTitle?.length;
    const brandedTitle = hasTitle ? `${pageTitle} | Konexus` : 'Konexus';

    if (AppConfig.isProd) {
      return brandedTitle;
    }

    const env = AppConfig.env ?? '';
    if (!env?.length) {
      return brandedTitle;
    }

    const envLabel = env.charAt(0).toUpperCase() + env.slice(1);
    return hasTitle ? `${envLabel} - ${pageTitle} | Konexus` : `${envLabel} | Konexus`;
  }
}
